/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ClientApplicationLastUsedTimeStatQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  applicationId: Types.Scalars['UUID']['input'];
}>;


export type ClientApplicationLastUsedTimeStatQuery = { __typename: 'Query', employeeSessions?: { __typename: 'ClientEmployeeSessionTypeConnection', aggregate?: { __typename: 'ClientEmployeeSessionAggregateType', max?: { __typename: 'ClientEmployeeSessionAggregateMaxFieldType', updatedAt?: string | null } | null } | null } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const ClientApplicationLastUsedTimeStatDocument = new TypedDocumentString(`
    query ClientApplicationLastUsedTimeStat($clientId: UUID!, $applicationId: UUID!) {
  employeeSessions(clientId: $clientId, applicationId: $applicationId) {
    aggregate {
      max {
        updatedAt
      }
    }
  }
}
    `);

export const useClientApplicationLastUsedTimeStatQuery = <
      TData = ClientApplicationLastUsedTimeStatQuery,
      TError = unknown
    >(
      variables: ClientApplicationLastUsedTimeStatQueryVariables,
      options?: Omit<UseQueryOptions<ClientApplicationLastUsedTimeStatQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientApplicationLastUsedTimeStatQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientApplicationLastUsedTimeStatQuery, TError, TData>(
      {
    queryKey: ['ClientApplicationLastUsedTimeStat', variables],
    queryFn: fetcher<ClientApplicationLastUsedTimeStatQuery, ClientApplicationLastUsedTimeStatQueryVariables>(ClientApplicationLastUsedTimeStatDocument, variables),
    ...options
  }
    )};

useClientApplicationLastUsedTimeStatQuery.getKey = (variables: ClientApplicationLastUsedTimeStatQueryVariables) => ['ClientApplicationLastUsedTimeStat', variables];

export const useInfiniteClientApplicationLastUsedTimeStatQuery = <
      TData = InfiniteData<ClientApplicationLastUsedTimeStatQuery>,
      TError = unknown
    >(
      variables: ClientApplicationLastUsedTimeStatQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientApplicationLastUsedTimeStatQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientApplicationLastUsedTimeStatQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientApplicationLastUsedTimeStatQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ClientApplicationLastUsedTimeStat.infinite', variables],
      queryFn: (metaData) => fetcher<ClientApplicationLastUsedTimeStatQuery, ClientApplicationLastUsedTimeStatQueryVariables>(ClientApplicationLastUsedTimeStatDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientApplicationLastUsedTimeStatQuery.getKey = (variables: ClientApplicationLastUsedTimeStatQueryVariables) => ['ClientApplicationLastUsedTimeStat.infinite', variables];


useClientApplicationLastUsedTimeStatQuery.fetcher = (variables: ClientApplicationLastUsedTimeStatQueryVariables) => fetcher<ClientApplicationLastUsedTimeStatQuery, ClientApplicationLastUsedTimeStatQueryVariables>(ClientApplicationLastUsedTimeStatDocument, variables);
